import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['adminRadio', 'voterBeforeOption', 'voterAfterOption']

  declare readonly adminRadioTargets: HTMLInputElement[]
  declare readonly voterBeforeOptionTarget: HTMLInputElement
  declare readonly voterAfterOptionTarget: HTMLInputElement
  declare readonly hasVoterAfterOptionTarget: boolean

  connect(): void {
    this.syncVoterOptions()
  }

  syncVoterOptions(): void {
    const checkedAdmin = this.adminRadioTargets.find((r) => r.checked)
    const adminIsAfter = !checkedAdmin || checkedAdmin.value === 'after'

    this.voterBeforeOptionTarget.disabled = adminIsAfter

    if (adminIsAfter && this.voterBeforeOptionTarget.checked) {
      this.voterBeforeOptionTarget.checked = false
      if (this.hasVoterAfterOptionTarget) {
        this.voterAfterOptionTarget.checked = true
      }
    }
  }
}
